import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";
import TreeViewSelectProvider from "../../components/TreeView/TreeViewSelectProvider";
import SupportRoot from "./SupportRoot";
import UpdateChecker from "../UpdateChecker";
import Authenticated from "../Authenticated";

function Support() {

    return (
        <Authenticated>
            <TreeViewSelectProvider>
                <UpdateChecker />
                <BreadcrumbsProvider>
                    <SupportRoot />
                </BreadcrumbsProvider>
            </TreeViewSelectProvider>
        </Authenticated>
    );

}

export default Support;